import { ChakraProvider, extendTheme } from '@chakra-ui/react';

export { ChakraProvider };

// Rely brand theme for Chakra UI
export const relyTheme = extendTheme({
  colors: {
    brand: {
      50: '#f0fdf4',
      100: '#dcfce7',
      200: '#bbf7d0',
      300: '#86efac',
      400: '#71DE80',
      500: '#71DE80',
      600: '#5BC469',
      700: '#45A952',
      800: '#2F8E3B',
      900: '#1A7324',
    },
  },
  fonts: {
    heading: `'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif`,
    body: `'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif`,
  },
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
});
